import React from "react";
import styled				from 'styled-components'
import SubscribeFormContainer from "./SubscribeFormContainer"
import SubscribeFormUserContainer from "./SubscribeFormUserContainer"
import SubscribeChoice from "./SubscribeChoice"
import {TextField, SecondaryButton} from "../Ui"
import Banner from "../common/components/layouts/Banner";



export default class SubscribeRoute extends React.Component {

	render() {

		const LOGO_LEGALLAIS_URL = require("../../assets/legallais.png")

		const Footer = styled.footer`
			margin-top: auto;
			padding: 10px;
			text-align: center;
			font-size: 14px;
			font-weight: 500;
		`

		return (
			<div className="subscribe">
				<Banner />
				<SubscribeChoice />
				<div className="susbcribe__button">
					<SecondaryButton className="subcribe__help-button" iconName="help">
						<span>Aide</span>
					</SecondaryButton>
				</div>
				<Footer className="subscribe-choice__footer">
					<span>Un outil pour créer vos organigrammes par <img src={LOGO_LEGALLAIS_URL} /></span>
				</Footer>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/subscribe/SubscribeRoute.js